import React from 'react';
import './footer.css';

import app_store from '../img/app-store.svg';
import google_play from '../img/google-play.svg';
import logo_footer from '../img/logo-footer.svg';

const Footer = ({ fullWidth = false }) => {
  const ContainerWrapper = ({ children }) => {
    if (fullWidth) {
      return <div className="container-fluid footer-wide-container">{children}</div>;
    }
    return <div className="container">{children}</div>;
  };

  return (
    <footer className="footer-section">
      <ContainerWrapper>
        <div className="footer-top-part">
          <div className="footer-columns-wrapper">
            {/* Колонка 1: Міська платформа */}
            <div className="footer-col">
              <h6>Міська платформа</h6>
              <ul className="list-unstyled">
                <li><a href="#">Каталог сервісів</a></li>
                <li><a href="#">Часті питання</a></li>
                <li><a href="#">Новини міста</a></li>
              </ul>
            </div>
            
            {/* Колонка 2: Соціальні мережі */}
            <div className="footer-col">
              <h6>Соціальні мережі</h6>
              <div className="social-icons">
                <a href="#"><i className="fab fa-facebook-f"></i></a>
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-telegram-plane"></i></a>
              </div>
            </div>
            
            {/* Колонка 3: Мобільний застосунок */}
            <div className="footer-col">
              <h6>Мобільний застосунок</h6>
              <div className="app-stores">
                <a href="#"><img src={app_store} alt="App Store" /></a>
                <a href="#"><img src={google_play} alt="Google Play" /></a>
              </div>
            </div>
            
            {/* Колонка 4: Логотип */}
            <div className="footer-col footer-logo-col">
              <div className="footer-logo-wrapper">
                <a className="footer-brand" href="#">
                  <img src={logo_footer} alt="Logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <hr className="footer-divider" />
        
        <div className="footer-bottom-part">
          <p>
            2025 © Київська міська державна адміністрація, Київська міська рада
          </p>
          <p>
            <span>E-mail: <a href="mailto:support.my@kyivcity.gov.ua">support.my@kyivcity.gov.ua</a></span>
            <span>Тел: <a href="tel:0443668027">(044) 366-80-27</a></span>
          </p>
        </div>
      </ContainerWrapper>
    </footer>
  );
};

export default Footer;